import { render, staticRenderFns } from "./plaingold.vue?vue&type=template&id=547cf590&scoped=true&"
import script from "./plaingold.vue?vue&type=script&lang=js&"
export * from "./plaingold.vue?vue&type=script&lang=js&"
import style0 from "./plaingold.vue?vue&type=style&index=0&id=547cf590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547cf590",
  null
  
)

export default component.exports